/* eslint-disable  no-irregular-whitespace */
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { UIHeading2, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { useCpdTracking } from 'shared/containers/valuationTraps/utils/tracking/cpd';

import bgImg from './assets/bg.png';
import * as styles from './styles.css';

interface ICPDSuccessScreenProps {
  cpdDraftId?: number;
  isHomeowner?: boolean;
  successButton: React.ReactNode;
}

export const CPDSuccessScreen: React.FC<ICPDSuccessScreenProps> = ({ cpdDraftId, isHomeowner, successButton }) => {
  const { trackCPDSuccessScreenVisible } = useCpdTracking(isHomeowner);

  return (
    <ActionAfterViewObserver callback={() => trackCPDSuccessScreenVisible(cpdDraftId)} callbackDelay={1000}>
      <div className={styles['container']}>
        <img className={styles['img']} src={bgImg} />
        <div className={styles['title']}>
          <UIHeading2>Скоро перезвоним</UIHeading2>
        </div>
        <div className={styles['text']}>
          <UIText2>С 9 до 21 по Мск менеджер позвонит вам, чтобы обсудить детали</UIText2>
        </div>
        {successButton}
      </div>
    </ActionAfterViewObserver>
  );
};
